(() => {
	const initSliders = () => {
		const slideshows = document.querySelectorAll(".slideshow__swiper");
		slideshows.forEach((slideshow) => {
			const autoplay =
				slideshow.getAttribute("data-autoplay") === "true" ? true : false;
			const slideshowSwiper = new Swiper(slideshow, {
				navigation: {
					nextEl: ".slideshow__button--next",
					prevEl: ".slideshow__button--prev",
				},
				pagination: {
					el: ".slideshow__navigation",
					type: "fraction",
				},
				loop: true,
				autoHeight: false,
			});
			if (autoplay) {
				slideshowSwiper.autoplay.run();
				slideshowSwiper.autoplay.running = true;
				slideshow.addEventListener("mouseenter", () => {
					slideshowSwiper.autoplay.pause();
				});
				slideshow.addEventListener("mouseleave", () => {
					slideshowSwiper.autoplay.run();
				});
			}
		});
	};
	initSliders();

	document.addEventListener("shopify:section:load", function () {
		initSliders();
	});
})();

/* ==========================================================================
   Slideshow — indicateur de swipe mobile (points discrets), même logique
   que les cartes produit. Le swipe tactile est géré nativement par Swiper.
   ========================================================================== */
(function () {
  function setupSlideshowDots() {
    document.querySelectorAll('.slideshow__swiper').forEach(function (el) {
      var sw = el.swiper;
      if (!sw || el.querySelector(':scope > .slideshow__dots')) return;
      var count = el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
      if (count < 2) return;

      var dots = document.createElement('div');
      dots.className = 'slideshow__dots';
      dots.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < count; i++) dots.appendChild(document.createElement('i'));
      el.appendChild(dots);

      function update() {
        var idx = sw.realIndex || 0;
        for (var j = 0; j < dots.children.length; j++) {
          dots.children[j].classList.toggle('is-active', j === idx);
        }
      }
      update();
      sw.on('slideChange', update);
      sw.on('realIndexChange', update);
    });
  }
  setupSlideshowDots();
  document.addEventListener('shopify:section:load', function () { setTimeout(setupSlideshowDots, 50); });
})();
